import React from 'react';
// Constants
import {
  CONTACT_PAGE_URL,
  EXTRA_LINKS_URL,
  GALLERY_PAGE_URL,
  REAL_TIME_URL,
} from '../../utils/Routes';

function CallToActionOne() {
  const buttons = [
    {
      text: 'Spoil Me',
      link: EXTRA_LINKS_URL,
      ariaLabel: 'Send a tribute to Miss Dominatrixa',
    },
    {
      text: 'Gallery',
      link: GALLERY_PAGE_URL,
      ariaLabel: 'Read what others say about Miss Dominatrixa',
    },
    {
      text: 'Book Now',
      link: CONTACT_PAGE_URL,
      ariaLabel: 'Book a session with Miss Dominatrixa',
    },
    {
      text: 'Real Time',
      link: REAL_TIME_URL,
      ariaLabel: 'View Miss Dominatrixa’s offerings',
    },
    {
      text: 'My Links',
      link: EXTRA_LINKS_URL,
      ariaLabel: 'Explore Miss Dominatrixa’s online presence',
    },
  ];

  return (
    <section className='grid justify-center h-fit md:grid-flow-col mx-auto gap-x-4 gap-y-4 py-10 sm:py-4 lg:py-8 bg-colour3 dark:bg-colour5 full_shadow_black_invert'>
      {buttons.map((btn, index) => (
        <a
          key={index}
          href={btn.link}
          title={btn.text}
          className={`cursor-pointer border-4 border-solid border-colour2 bg-colour4 text-colour5 px-8 w-full text-center lg:w-fit h-fit md:px-2 lg:px-6 py-1 rounded mx-auto font-titleFont lg:text-lg 
          hover:bg-colour3 hover:text-white 
          dark:border-colour5 dark:bg-colour5 dark:text-colour2 dark:hover:bg-colour3 dark:hover:text-colour5 shadow-cardShadow`}
          aria-label={btn.ariaLabel}
        >
          {btn.text}
        </a>
      ))}
    </section>
  );
}

export default CallToActionOne;
